export { VehicleGeneral } from "./vehicle-general";
